module.exports = __webpack_public_path__ + "593a3d53/img/settings-ico.a214628d.svg";